import React, {useEffect, useState} from "react";
import "./BasketAddRemove.scss";
import {useBasket, useDispatchBasket} from "../../hooks";
import {AddBasket, RemoveBasket} from "../OnlineAddress/OnlineAddressService";
import {openNotificationWithIcon} from "../../Services";
import {useHistory} from "react-router-dom";

function BasketAddRemove({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const history = useHistory();

    //states
    const [loading,set_loading] = useState(false)



    useEffect(()=>{

    },[])

    const addToBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId,pId,item)
        // console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId,pId)
        // console.log("Remove : ",response)
    }

    //functions
    const inc = async () =>{
        if(loading){return }
       try{
           set_loading(true)
           //ADD API
           await addToBasket(item.uid);
           let merchantId = window.location.pathname.split("/")[2]
           openNotificationWithIcon('success',item,history,merchantId)
           set_loading(false)
       }catch (e) {
           set_loading(false)
           return ;
       }
        // console.log("item : ",item)
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if(basket.find(product=>product.product.uid===item.uid)){
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count+1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket",JSON.stringify(filter));
        }else {
            //not exist
            //context change
            setBasket(oldArray => [...oldArray, {product:item,count:1}]);
            //storage change
            localStorage.setItem("basket",JSON.stringify([...basket, {product:item,count:1}]));
        }


    }

    const dec =async () =>{
        if(loading){return }
        try{
            set_loading(true)
             //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product=>product.product.uid===item.uid);
        if(find){
            //exist
            if(find.count>0){
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count-1} : pro)

                if(find.count===1){
                    //context change
                    setBasket(basket.filter(product=>product.product.uid!==item.uid))
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                }else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(filter));
                }
            }else {
                //context change
                setBasket(basket.filter(product=>product.product.uid!==item.uid))
                //storage change
                localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
            }
        }


    }

    // const remove = () =>{
    //     //--------------------------------- Context Change ----------------------------------------------
    //     setBasket(basket.filter(product=>product.product.uid!==item.uid))
    //     //--------------------------------- Local Storage Change ----------------------------------------------
    //     setTimeout(()=>{
    //         localStorage.setItem("basket",JSON.stringify(basket));
    //     },500)
    // }

    const checkCount = () => {
        let basket_count = basket.find(product=>product.product.uid===item.uid);
        if(basket_count){
            return basket_count.count;
        }
        return 0;
    }



    return(
        <div className="add-remove-section">
            {item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:<span className="stock-over">ناموجود</span>}
            {checkCount()>0?<>
                <span className="product-count-number">
                    {!loading?checkCount():<i className="fa fa-spinner fa-spin"></i>}
                </span>
                <i className="fa fa-minus" onClick={dec}></i>
            </>:null}

        </div>
    )
}

export {BasketAddRemove}
